// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyAkNuLFFWhJ99euXtJlOlmIvYo4ql7W9D8",
    authDomain: "scapps-78804.firebaseapp.com",
    databaseURL: "https://scapps-78804.firebaseio.com",
    projectId: "scapps-78804",
    storageBucket: "scapps-78804.appspot.com",
    messagingSenderId: "365559889870"
  },
  emailApiUrl: "http://dhukuti.booleanapps.com/services/email.php"
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
